module.exports = __webpack_public_path__ + "static/wiz1-680ca9212e38c4ef8e9385ee56320925.jpg";